import http from 'utils/http';
import { getTalksUrl } from './apiUrls';
import { TalksRequest } from './types';

export function handleCreateTalks(
  workspaceId: string,
  agentId: string,
  payload: TalksRequest
): Promise<{ meta: { message: string } }> {
  return http.post(getTalksUrl(workspaceId, agentId), payload);
}
